import { render, staticRenderFns } from "./SFormPriceProductComp.vue?vue&type=template&id=ab5d6da8&"
import script from "./SFormPriceProductComp.vue?vue&type=script&lang=js&"
export * from "./SFormPriceProductComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports